import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { LinkyPipe } from 'ngx-linky';
import { NewLinePipe } from '@sb-tools/typescript/pipes/new-line.pipe';
import { MessageDTO } from '../../models/dto/message.dto';
import { EncodeHtmlSymbolsPipe } from '../encode-html-symbols.pipe';
import { HttpLinkPipe } from './http-link.pipe';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'prepareMessage',
})
export class PrepareMessagePipe implements PipeTransform {
    constructor(
        private linkyPipe: LinkyPipe,
        private httpLinkPipe: HttpLinkPipe,
        private newLinePipe: NewLinePipe,
        private encodeHtmlSymbolsPipe: EncodeHtmlSymbolsPipe,
    ) {}

    transform(message: MessageDTO): string {
        if (!message) {
            return '';
        }

        let filteredMessage = message.html || message.text;

        if (!message.html) {
            filteredMessage = this.encodeHtmlSymbolsPipe.transform(filteredMessage);
            filteredMessage = this.newLinePipe.transform(filteredMessage);
        }

        filteredMessage = this.linkyPipe.transform(filteredMessage, {
            urls: { tldMatches: false },
        });

        filteredMessage = this.httpLinkPipe.transform(filteredMessage);
        return filteredMessage;
    }
}
